import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import axios from "axios";
import ProjectMultiSelect from './MultiSelect';
import './App.css'

// start chrome --disable-web-security --user-data-dir="C:/ChromeDev"

// const api = "https://rjr3kc4t0m.execute-api.us-east-1.amazonaws.com/dev/conversation"
// const api = "https://3903grqr2h.execute-api.us-east-1.amazonaws.com/dev/conversation"

const apis = {
  "opcion1": "https://3rwvxvk3o7.execute-api.us-east-1.amazonaws.com/dev/backend",
  "opcion2": "https://3903grqr2h.execute-api.us-east-1.amazonaws.com/dev/conversation"
}

// const proyectos = [
//   { id: '1', name: 'Proyecto Alpha' },
//   { id: '2', name: 'Proyecto Beta' },
//   { id: '3', name: 'Proyecto Gamma' },
// ];


function App() {

  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [buttonEnabled, setButtonEnabled] = useState(true);
  const [chatId, setChatId] = useState(0);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proyectos, setProyectos] = useState([]);


  const [selectedOption, setSelectedOption] = useState("opcion1");

  const handleChangeCombobox = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {

    // console.log(convertStringToJson("(['nombre_cliente', 'id_cliente'], [('CAMILA CLAVIJO', 'C001315'), ('CAMILA MANDUJANO', 'C001462')])"));

    const body = {
      "type": "get"
    }
    axios.post(apis[selectedOption], body, {})
    .then((response) => {
      console.log(response)
      const chatid = JSON.parse(response["data"]["new_chat_id"])
      console.log(chatid)
      setChatId(chatid)
      
      const hs = JSON.parse(response["data"]["historial"])
      console.log(hs)
      setHistorial(hs.map((e) => {
        return {
          "chat_id": e[0],
          "encabezado": e[1]
        }
      }))

      const proyectosResponse = JSON.parse(response["data"]["folders"]).map((value, idx) => {
        return {
          'id': idx+1,
          'name': value,
          'selected': false
        }
      })

      setProyectos(proyectosResponse);

    })
    .catch((error) => console.log(error))

  }, [])


  useEffect(() => {
    console.log("MESSAGES UPDATED")
  }, [messages])

  const convertStringToJson = (str) => {
    // // Extraer los valores entre corchetes
    // const match = str.match(/\(\[(.*?)\], \[(.*?)\]\)/);
    // if (!match) return [];

    // // Obtener encabezados y filas
    // const headers = match[1].replace(/'/g, "").split(", ");
    // const rows = match[2].match(/\('(.*?)', '(.*?)'\)/g).map(row => 
    //     row.replace(/\(|\)/g, "").split(", ").map(val => val.replace(/'/g, ""))
    // );

    // // Convertir a array de objetos
    // const result = rows.map(row => {
    //     return headers.reduce((obj, header, index) => {
    //         obj[header] = row[index];
    //         return obj;
    //     }, {});
    // });

    // return (result);
    str = str.replace(/'/g, '"');
    str = str.replace(/Decimal\("(\d+)"\)/g, "$1");
    console.log("STR: ", str);
    const parsedArray = JSON.parse(str);

    if (selectedOption == "opcion1" || selectedOption == "opcion2")
      return parsedArray;

    // Extraer encabezados y datos
    const headers = parsedArray[0]; 
    const data = parsedArray[1]; 
    
    // Convertir los datos en un array de objetos
    const result = data.map(row => {
      return Object.fromEntries(headers.map((key, index) => [key, row[index]]));
    });
    return result;    
    // // Convertir el resultado a una cadena JSON
    // const outputString = JSON.stringify(result);
  };

  const process_query = async (newMessages) => {

    setLoading(true);
    const body = {
        "type": "process",
        "query": inputValue,
        "chat_id": chatId.toString(),
        "projects": proyectos.filter((i) => i.selected).map((i) => i.name)
    }
    console.log(body);

    await axios.post(apis[selectedOption], body, {}
    ).then((response) => {
      console.log(response);
      
      const result = (response["data"]["result"]);
     

      // if (response["data"]["historial"]) {
      //   const hs = JSON.parse(response["data"]["historial"])
      //   console.log(hs)
      //   setHistorial(hs.map((e) => {
      //     return {
      //       "chat_id": e[0],
      //       "encabezado": e[1]
      //     }
      //   }))
      // }

      setMessages([...newMessages, {
        'text': result,

      }]);
      setButtonEnabled(true);
      setLoading(false);
    }).catch((error) => console.log(error));
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const sendMessage = async (event) => {
    event.preventDefault();
    if (inputValue.length > 0 && buttonEnabled) {
      const newMessages = [...messages, {
        'text': inputValue
      }];
      setMessages(newMessages);
      process_query(newMessages);
      setInputValue("");
      setButtonEnabled(false);
    }
  }

  const getChatContext = (chat_id) => {
    console.log("CHAT ID", chat_id)
    setMessages([]);
    setChatId(chat_id);
    setLoading(true);
    const body = {
        "type": "context",
        "chat_id": chat_id.toString()
    }
    axios.post(apis[selectedOption], body, {})
    .then((response) => {
      const context = JSON.parse(response["data"]["context"])
      console.log("CONTEXT: ", context);

      // const ctx = (context)[0]
      // console.log(ctx)
      const newMessages = [];
      for (let i=0; i<context.length; i++) {

        newMessages.push({
          'text':  context[i][0],
        });
        newMessages.push({
          'text':  context[i][1],
        });
        // newMessages.push({
        //   'text': ctx[i+1],
        //   // 'sql_query': ctx_unit[2] ? "\n\n" + ctx_unit[2] + "\n\n" : ctx_unit[2],
        //   // 'query_result': ctx_unit[3],
        // });
      }
      console.log(newMessages)
      setMessages(newMessages);
      setLoading(false);
    })
    .catch((error) => console.log(error))

  }

  const newChat = () => {
    setChatId(0)
    setMessages([])
    setInputValue("")
    setButtonEnabled(true)
    const body = {
      "type": "get"
    }
    axios.post(apis[selectedOption], body, {})
    .then((response) => {
      console.log(response)
      const chatid = JSON.parse(response["data"]["new_chat_id"])
      console.log(chatid)
      setChatId(chatid)
    })
    .catch((error) => console.log(error))
  }


  return (
    <div className="App">

      <div id='historial' className='scrollable'>
        {
          historial.map((chat, index) => 
            <div key={index} className={'chat' + (chatId == chat["chat_id"] ? ' selected' : '')} id={"chat-" + index} onClick={() => getChatContext(chat["chat_id"])}>
              {chat["encabezado"]}
            </div>
          )
        }
      </div>

      <div id='messagesContainer' className='scrollable'>
        <div id='messages'>
          {
            messages.map((message, index) =>
            <div key={index} id={"message-" + index} className={'message ' + (index % 2 == 1 ? 'bot' : 'human')}>
              {
                  message["text"].split("\n").map((parrafo, indexx) =>  (
                    <React.Fragment key={indexx}>
                      {parrafo}
                      <br />
                    </React.Fragment>
                  ))
              }

              {/* {
                message["sql_query"] ?
                (
                    <div >
                      <br />
                      {message["sql_query"]}
                    </div>
                )
                :
                (<></>)
              } */}
              
              {
                message["query_result"] && message["query_result"] != "None" ?
                (
                  <div>
                    <br />
                  <table className="table-auto border-collapse border border-gray-400" style={{ whiteSpace: "pre-line" }}>
                    <thead>
                      <tr>
                        {[...new Set((convertStringToJson(message["query_result"])).flatMap(Object.keys))].map((col) => (
                          <th key={col} style={{paddingRight: "24px"}}>{col}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(convertStringToJson(message['query_result'])).map((item, index) => (
                        <tr key={index} >
                          {[...new Set((convertStringToJson(message["query_result"])).flatMap(Object.keys))].map((col) => (
                            <td key={col} style={{paddingRight: "24px"}}>
                              {item[col] || "-"} {/* Muestra "-" si no existe el dato */}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  </div>
                )
                :
                (<></>)
              }
            </div>)
          }
          {
              loading ?
              (<div id='loading'>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots" viewBox="0 0 16 16">
                  <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/>
                </svg>
              </div>)
              :
              (<></>)
          }
        </div>

      </div>

      <div id='query'>
        <form action="" onSubmit={sendMessage}>
          <input type='text' placeholder='Escribe un mensaje'         
            value={inputValue} 
            onChange={handleChange} 
          ></input>
          <button className='send-button' type="submit">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
              <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z"/>
            </svg>
          </button>
        </form>
      </div>
      
      <div id='new-chat' onClick={newChat}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
      </svg>
      </div>
      
      {/* <div id='model'>
        <select id="comboBox" value={selectedOption} onChange={handleChangeCombobox}>
          <option value="opcion1">Sonnet</option>
          <option value="opcion2">Deepseek</option>
        </select>
      </div> */}

      <ProjectMultiSelect
        projects={proyectos}
        onChange={(seleccionados) => {
          console.log('Seleccionados:', seleccionados);
          const newProyectos = JSON.parse(JSON.stringify(proyectos));
          for (let i=0; i<newProyectos.length; i++) {
            newProyectos[i].selected = false;
            for (let j=0; j<seleccionados.length; j++) {
              if (seleccionados[j].id == newProyectos[i].id) {
                newProyectos[i].selected = true;
                break;
              }
            }
          }
          setProyectos(newProyectos);

        }}
      />

    </div>
  );
}

export default App;
